<template>
    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">Alerts</h1>
                            <h4 class="font-weight-light  text-white">MANAGE ALERTS</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="boxes-hero">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12 my-2">
                        <div class="box shadow-lg bg-white rounded">

                            <div class="box-header bg-light-blue rounded-top p-3">
                                <div class="row">
                                    <div class="col">
                                        Alert List
                                    </div>
                                    <div class="col text-right">
                                        <button class="btn btn-light btn-rounded" data-toggle="modal" data-target="#newDevice">
                                            <router-link
                                                    :to="'/alerts/create'"
                                            > + New Alert
                                            </router-link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div style="padding: 10px">
                                <k-table
                                    :title="false"
                                    :ids="ids"
                                    :items="items"
                                    :tableName="tableName"
                                    :fields="fields"
                                    :loading="loading"
                                    :stacked="false"
                                    :pagination="false"
                                    @edit_item="edit_item"
                                    @delete_item="delete_item"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getAlertsByAccount, updateAlert, getAlertTypes } from '../../networking/alerts'
    import { map_alerts_to_units } from '../../helpers/alerts'
    import KTable from '../../widgets/KTable'

    const fields = [
        { key: 'alertName', label:'Alert Name', sortable: false },
        { key: 'alertTypeDesc', label: 'Type', sortable: false },
        { key: 'computed_threshold', label: 'Threshold', sortable: false },
        { key: 'action', label: '', sortable: false }
    ]

    export default {

        props:{
            userData: { type: Object, required: true },
            search_string:{ type: String },
            trigger_search: { type: Boolean }
        },

        components: { KTable },
        data() {
            return {
                ids: [],
                fields: fields,
                items: [],
                tableName: 'Alert',
                loading: true,
                //tableLink: { id:'alert-create', to:'/alerts/create', text:'+ Create Alert' },
                alert_types: []
            }
        },
        async created(){ this.get_alerts()},
        methods:{
            async get_alerts() {
                await this.get_alert_types()
                const generator = getAlertsByAccount(this.userData.accountId)
                const { value: { data = [] }} = await generator.next()

                this.items = data.filter(({alertType}) =>
                    this.alert_types.find(({value}) => alertType === value)
                ).map(({alertType, ...alert}) => ({
                    ...alert,
                    computed_threshold: map_alerts_to_units({ alertType, ...alert }),
                    disableDelete: !this.alert_types.find(({value}) => alertType === value).iseditable,
                    alertType: alertType
                }))
                this.loading = false
            },

            async delete_item(id) {
                const generator = updateAlert({...this.items.find((alert) => alert.id === id), enabled: 0})
                const { value: { alert, data = [] }} = await generator.next()
                this.$emit('showAlert', alert.message, alert.variant, alert.variant === 'success' ? 1800 : 5000)
                alert.variant === 'success' ? this.get_alerts() : null
            },
            async edit_item(id) {
                this.$router.push('alerts/' + id)
            },
            async get_alert_types(){
                const { value: { data = [] }} = await getAlertTypes()
                this.alert_types = data.filter(({ ishidden, isenabled }) => isenabled && !ishidden )
            }           
        }
    }

</script>

<style scoped>
    .text-primary { color: orange!important }
</style>
